module.exports = "/images/vendor/vue-paycard/src/13.jpg?3a7faba6ab401bf9b60335cd0a54badb";